import {Model} from 'vue-mc';
import Vue from "vue";
import http from "../httpMiddleware/http";

Model.prototype.$http = http;
export default class workingWithChildrenModel extends Model {

	defaults() {
		return {
			inBuiltApi: Vue.prototype.$interpretersApiUrl,
			methodTypes: 'view',
			file_name: '',
			data: {
				validFrom: '',
				validTo: '',
				base64: '',
				type: '',
				ext: ''
			}
		}
	}

	options() {
		return {
			methods: {
				view: 'GET',
				save: 'POST'
			}
		}
	}

	routes() {
		return {
			view: 'interpreter/children_check/get_image?token=',
			save: 'interpreter/children_check/send'
		}
	}

	requestRoute() {
		let headers = {
			Bearer: localStorage.getItem('jwt')
		};
		let method = this.getOption('methods.' + this.methodTypes);
		let route = this.inBuiltApi + this.getRoute(this.methodTypes);
		let params = this.getRouteParameters();
		let url = this.getURL(route, params);
		let data = this.data;

		// console.log(headers, method, url, data);

		return this.getRequest({headers, method, url, data}).send();
	}

	saveFile() {
		this.methodTypes = 'save';
		return this.requestRoute();
	}
}
